/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Cart App Tier
 * This is to provide all the cart related operations at cart app tier.
 *
 * The version of the OpenAPI document: v2
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Profile } from './Profile';
import {
    ProfileFromJSON,
    ProfileFromJSONTyped,
    ProfileToJSON,
} from './Profile';
import type { RenewalFlag } from './RenewalFlag';
import {
    RenewalFlagFromJSON,
    RenewalFlagFromJSONTyped,
    RenewalFlagToJSON,
} from './RenewalFlag';

/**
 * 
 * @export
 * @interface AmwayUserDetails
 */
export interface AmwayUserDetails {
    /**
     * 
     * @type {Array<Profile>}
     * @memberof AmwayUserDetails
     */
    profiles?: Array<Profile>;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    status?: AmwayUserDetailsStatusEnum;
    /**
     * 
     * @type {RenewalFlag}
     * @memberof AmwayUserDetails
     */
    renewalFlag?: RenewalFlag;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    renewalLifeCycle?: string;
    /**
     * 
     * @type {Date}
     * @memberof AmwayUserDetails
     */
    expirationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AmwayUserDetails
     */
    lastRenewedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AmwayUserDetails
     */
    entryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    sponsor?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    uplineDiamond?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    uplinePlatinum?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    currentAwardLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    highestAwardLevel?: string;
    /**
     * line of affiliation
     * @type {string}
     * @memberof AmwayUserDetails
     */
    loaCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    amwayUserId: string;
    /**
     * 
     * @type {string}
     * @memberof AmwayUserDetails
     */
    accountId?: string;
}


/**
 * @export
 */
export const AmwayUserDetailsStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type AmwayUserDetailsStatusEnum = typeof AmwayUserDetailsStatusEnum[keyof typeof AmwayUserDetailsStatusEnum];


/**
 * Check if a given object implements the AmwayUserDetails interface.
 */
export function instanceOfAmwayUserDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amwayUserId" in value;

    return isInstance;
}

export function AmwayUserDetailsFromJSON(json: any): AmwayUserDetails {
    return AmwayUserDetailsFromJSONTyped(json, false);
}

export function AmwayUserDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmwayUserDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profiles': !exists(json, 'profiles') ? undefined : ((json['profiles'] as Array<any>).map(ProfileFromJSON)),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'accountType': !exists(json, 'accountType') ? undefined : json['accountType'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'renewalFlag': !exists(json, 'renewalFlag') ? undefined : RenewalFlagFromJSON(json['renewalFlag']),
        'renewalLifeCycle': !exists(json, 'renewalLifeCycle') ? undefined : json['renewalLifeCycle'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (new Date(json['expirationDate'])),
        'lastRenewedDate': !exists(json, 'lastRenewedDate') ? undefined : (new Date(json['lastRenewedDate'])),
        'entryDate': !exists(json, 'entryDate') ? undefined : (new Date(json['entryDate'])),
        'sponsor': !exists(json, 'sponsor') ? undefined : json['sponsor'],
        'uplineDiamond': !exists(json, 'uplineDiamond') ? undefined : json['uplineDiamond'],
        'uplinePlatinum': !exists(json, 'uplinePlatinum') ? undefined : json['uplinePlatinum'],
        'currentAwardLevel': !exists(json, 'currentAwardLevel') ? undefined : json['currentAwardLevel'],
        'highestAwardLevel': !exists(json, 'highestAwardLevel') ? undefined : json['highestAwardLevel'],
        'loaCode': !exists(json, 'loaCode') ? undefined : json['loaCode'],
        'amwayUserId': json['amwayUserId'],
        'accountId': !exists(json, 'accountId') ? undefined : json['accountId'],
    };
}

export function AmwayUserDetailsToJSON(value?: AmwayUserDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profiles': value.profiles === undefined ? undefined : ((value.profiles as Array<any>).map(ProfileToJSON)),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'accountType': value.accountType,
        'status': value.status,
        'renewalFlag': RenewalFlagToJSON(value.renewalFlag),
        'renewalLifeCycle': value.renewalLifeCycle,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate.toISOString()),
        'lastRenewedDate': value.lastRenewedDate === undefined ? undefined : (value.lastRenewedDate.toISOString()),
        'entryDate': value.entryDate === undefined ? undefined : (value.entryDate.toISOString()),
        'sponsor': value.sponsor,
        'uplineDiamond': value.uplineDiamond,
        'uplinePlatinum': value.uplinePlatinum,
        'currentAwardLevel': value.currentAwardLevel,
        'highestAwardLevel': value.highestAwardLevel,
        'loaCode': value.loaCode,
        'amwayUserId': value.amwayUserId,
        'accountId': value.accountId,
    };
}

